<template>
    <div/>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue';
    import { Validator } from 'vee-validate';
    export default {
        name: 'creditcard-validator',
        data: function () {
            return this.getDefaultData();
        },
        created: function () {
            Event.$on('validateCreditcard', this.onValidateCreditcard);
            this.validator = new Validator();
            this.validator.attach('owner', 'required');
            this.validator.attach('type', 'required');
            this.validator.attach('number', 'required');
            this.validator.attach('month', 'required');
            this.validator.attach('year', 'required');
            this.validator.attach('cvv', 'required|min:3');
        },
        beforeDestroy: function () {
            Event.$off('validateCreditcard', this.onValidateCreditcard);
        },
        methods: {
            getDefaultData: function () {
                return {
                    callback: ''
                };
            },
            notify: function (output) {
                if (this.callback.length > 0) {
                    Event.$emit(this.callback, output);
                }
            },
            onValidateCreditcard: function (data) {
                var payload = {
                    owner: data.credit_card_owner || '',
                    type: data.credit_card_type || '',
                    number: data.credit_card_number || '',
                    month: data.credit_card_month || '',
                    year: data.credit_card_year || '',
                    cvv: data.credit_card_cvv || ''
                };
                this.callback = data.callback || '';
                this.validator.validateAll(payload).then((result) => {
                    this.notify({ success: result });
                }).catch(() => {
                    this.notify({ success: false });
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// creditcard-validator.vue?5f115b06